/**
 * @file app/utils/advertising/constants.js
 */

export const APPCONTAINER_WP_WIDTH = 1024;
